<template>
  <div class="basicInfoInputItem container">
    <p class="basicInfoInputItem__title col-md-4 col-md-offset-1">
      {{ title }}
    </p>
    <input
      class="basicInfoInputItem__input col-md-6"
      :type="type"
      :value="value"
      :disabled="disabled"
      :class="{ 'basicInfoInputItem__input--disabled': disabled }"
      @input="handleInput($event)"
    />
    <!-- 提醒文字 -->
    <p v-if="hint" class="basicInfoInputItem__hint col-md-12 col-md-offset-1">
      {{ hint }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    value: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    hint: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    handleInput(event) {
      const { value } = event.target
      this.$emit('input', value)
    },
  },
}
</script>
<style lang="scss" scoped>
.basicInfoInputItem {
  &__title {
    text-align: center;
    font-size: 16px;
    margin-bottom: 0;
    line-height: 36px;
  }

  &__input {
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    border: 1px solid #ccc;
    border-radius: 4px;

    &--disabled {
      background: #d8d8d8;
    }
  }
  &__hint {
    color: #f56c6c;
    font-size: 16px;
    text-align: center;
    line-height: 1.2;
    margin: 0 0 0 30px;
    font-weight: 600;
    padding: 6px 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/input/BasicInfoInputItem.vue